import React from 'react';

// Types
import { User } from 'Shared/constants/types';

// Hooks
import { useBaTracking } from 'Shared/tracking/use-ba-tracking';
import { useCreateOrSendBa } from 'Shared/utils/hooks/use-create-or-send-ba';
import { useTranslation } from 'Shared/contexts/TranslationsContext';

// Components
import BaseCta from './BaseCta';

//Types
import { Illustrations } from 'Wpds/components/illustration';

type Props = {
  user: User;
};

const ResendBa = ({ user }: Props) => {
  const { trackSendAssessmentButtonClick } = useBaTracking();
  const { resendBaEmail, isCreatingBaLink } = useCreateOrSendBa({ user: user, isTakingBaForSelf: false });

  const handleButtonClick = async () => {
    trackSendAssessmentButtonClick();
    await resendBaEmail();
  };

  const { tr } = useTranslation();

  return (
    <BaseCta
      title={tr('perform.user_ui.user_ba_profile_snapshot.pending_assessment_title')}
      illustration={Illustrations.hourglass}
      illustrationName="hourglass"
      description={tr('perform.user_ui.user_ba_profile_snapshot.pending_assessment_desc', user.firstName)}
      buttonText={tr('perform.user_ui.user_ba_profile_snapshot.resend_assessment_cta')}
      buttonVariant="secondary"
      footerText={tr('perform.user_ui.user_ba_profile_snapshot.learn_more')}
      showDivider={false}
      showExternalLink={false}
      buttonConfirmationText={tr('perform.user_ui.user_ba_profile_snapshot.need_to_resend')}
      buttonSize="md"
      onButtonClick={handleButtonClick}
      loading={isCreatingBaLink}
    />
  );
};

export default ResendBa;
